export default "__VITE_ASSET__BFeuqPPZ__"